import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppService } from '@mavles/user';
import { AlertService } from '@mavles/shared';

export const adminGuard: CanActivateFn = () => {
  const appService = inject(AppService);
  const router = inject(Router);
  const alertService = inject(AlertService);

  if (appService.isAdmin()) {
    return true;
  }

  alertService.error('Access Denied: Administrative privileges required.');
  return router.parseUrl('/home');
};
